export default {
  getCrtInternalId: state => state.crtInternalId,
  getFetchNotaryCertificateStatus: state => state.fetchNotaryCertificateStatus,
  getCalculateMerkleRootStatus: state => state.calculateMerkleRootStatus,
  getMerkleTreeRoot: state => state.merkleTreeRoot,
  getJsonId: state => state.jsonId,
  getCrtHashRoot: state => state.crtHashRoot,
  getValidateHashStatus: state => state.validateHashStatus,
  getCalculateCrtIdStatus: state => state.calculateCrtIdStatus,
  getCalculatedCrtId: state => state.calculatedCrtId,
  getValidateMerkleStatus: state => state.validateMerkleStatus,
  getItemHash: state => state.itemHash,
  getHashList: state => state.hashList,
  getMerkleProof: state => state.merkleProof,
  getHashRoot: state => state.hashRoot,
  getMerkleRoot: state => state.merkleRoot,
  getEtheriumTransactionId: state => state.etheriumTransactionId,
  getDisplayFileName: state => state.displayFileName,
  getCrtDate: state => state.crtDate,
  getCrtSignee: state => state.crtSignee,
  getSplItemHash: state => state.splItemHash

};
